import {useEffect, useState} from "react";
import axios from "axios";
import {
	GET_ALL_MINE_TICKET_URL,
	GET_ALL_TICKET_ARCHIVIATI_URL,
	GET_ALL_TICKET_URL
} from "../../../../services/utils/ApiUrls";
import {getConfig} from "../../../../services/utils/ConfigUtils";
import {clean, getCompanyInfo, isEmpty} from "../../../../utils/GenericUtils";

export default function useGetAllTicket(stato, filters, pageNumber, idSoggetto, level, sort, dir, category = null,
                                        type = null, from = null, ticketSample, subCategory = null,
                                        ticketDst = null, query = "", esito = null) {
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(false);
	const [tickets, setTickets] = useState([]);
	const [hasMore, setHasMore] = useState(false);

	function getData(stato, filters, idSoggetto, level, category, type, from, ticketSample, subCategory, ticketDst, esito) {
		if (ticketSample && !isEmpty(ticketSample.search)) {
			if (ticketSample.search.id) {
				return {
					id: ticketSample.search.id,
					rispostaUtente: null,
					contattoMail: null,
					livello: level,
					active: null,
					type: from ? from : null,
					categoria: category,
					sottoCategoria: subCategory,
					esito: esito
				}
			} else {
				ticketSample = {
					search: {
						...clean(ticketSample.search),
						stato: stato,
						categoria: category,
						esito: esito,
						type: from ? from : null,
						sottoCategoria: subCategory,
						dst: ticketDst ? ticketDst : getCompanyInfo().roleDetails?.replace("ROLE_", ""),
						anagraficaToSearch: {
							...clean(ticketSample.search.anagraficaToSearch),
							codF: ticketSample.search.anagraficaToSearch?.codF ? ticketSample.search.anagraficaToSearch?.codF.toUpperCase() : null,
						}
					}
				}
				return {
					...ticketSample.search,
					livello: level,
					rispostaUtente: null,
					contattoMail: null,
					active: null,
					type: from ? from : null,
					categoria: category,
					sottoCategoria: subCategory,
					esito: esito,
				}
			}
		}
		if (idSoggetto) {
			return {
				idSoggetto: idSoggetto,
				livello: level,
				soggetto: {
					idSoggetto: idSoggetto,
				},
				rispostaUtente: null,
				contattoMail: null,
				categoria: category,
				type: from ? from : null,
				esito: esito,
				sottoCategoria: subCategory,
				dst: ticketDst ? ticketDst : getCompanyInfo().roleDetails?.replace("ROLE_", ""),
			}
		}
		if (filters === "CCM") {
			return {
				priority: null
			}
		}
		if (stato === "Aperto" || stato === "Preso in carico" || stato === "Risolto" || stato === "Nuovo" || stato === "In attesa" || stato === "Ripristinato") {
			return {
				active: false,
				rispostaUtente: null,
				contattoMail: null,
				stato: stato,
				dst: ticketDst ? ticketDst : getCompanyInfo().roleDetails?.replace("ROLE_", ""),
				src: type,
				esito: esito,
				type: from ? from : null,
				livello: level,
				categoria: category,
				sottoCategoria: subCategory,
				priority: filters === "" ? null : filters
			}
		} else {
			if (stato === "In gestione") {
				return {
					active: true,
					rispostaUtente: null,
					contattoMail: null,
					dst: ticketDst ? ticketDst : getCompanyInfo().roleDetails?.replace("ROLE_", ""),
					src: type,
					esito: esito,
					type: from ? from : null,
					livello: level,
					categoria: category,
					sottoCategoria: subCategory,
					priority: filters === "" ? null : filters
				}
			} else if (stato === "Risposte utente") {
				return {
					active: null,
					rispostaUtente: true,
					contattoMail: null,
					dst: ticketDst ? ticketDst : getCompanyInfo().roleDetails?.replace("ROLE_", ""),
					src: type,
					type: from ? from : null,
					esito: esito,
					livello: level,
					categoria: category,
					sottoCategoria: subCategory,
					priority: filters === "" ? null : filters
				}
			} else if (stato === "Archiviati") {
				return {
					active: null,
					rispostaUtente: null,
					contattoMail: null,
				}
			} else {
				return {
					active: null,
					rispostaUtente: null,
					contattoMail: null,
					dettaglioRichiesta: "richiesta_chiamata",
					dst: ticketDst ? ticketDst : getCompanyInfo().roleDetails?.replace("ROLE_", ""),
					src: type,
					type: from ? from : null,
					esito: esito,
					livello: level,
					categoria: category,
					sottoCategoria: subCategory,
					priority: filters === "" ? null : filters
				}
			}
		}
	}

	useEffect(() => {
		setTickets([]);
	}, [stato, filters, level, sort, dir, category, type, from, ticketSample, subCategory, ticketDst, esito])

	useEffect(() => {
		if (query.length === 0) {
			setLoading(true);
			setError(false);
			axios({
				method: "POST",
				url: (stato === "Le mie richieste" ? (GET_ALL_MINE_TICKET_URL + "/" + pageNumber + "/" + sort + "/" + dir) : stato === "Archiviati" ?
					(GET_ALL_TICKET_ARCHIVIATI_URL + pageNumber + "/" + sort + "/" + dir) :
					(GET_ALL_TICKET_URL + pageNumber + "/" + sort + "/" + dir)),
				data: getData(stato, filters, idSoggetto, level, category, type, from, ticketSample, subCategory, ticketDst, esito),
				...getConfig(),
			}).then(response => {
				let filtered = response.data;
				setTickets(prevState => {
					let newState = [...prevState, ...filtered];
					return newState.filter((object, index) => index === newState.findIndex(obj => JSON.stringify(obj) === JSON.stringify(object)))
				})
				setHasMore(filtered.length > 0);
				setLoading(false);
			}).catch(() => {
				setError(true);
				setLoading(false);
			})
		}
	}, [stato, pageNumber, filters, idSoggetto, level, sort, dir, type, from, ticketSample, subCategory, category, ticketDst, query, esito])

	return {loading, error, tickets, hasMore};
}
